import React from 'react';
import axios from 'axios';
import moment from 'moment';
import ReactGA from 'react-ga';
import MdArrowBack from 'react-ionicons/lib/MdArrowBack';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import '../css/subscription.css';

const SubBtn = ({ subscription, price, handleSubscribe, handleTerminate, handleManage, handleReactivate, handleUpgrade, subtext, engagedPriceId, periodLabel = '/ mois' }) => {
	const isActive = subscription?.status === 'active';
	const isCurrentPrice = subscription?.priceId === price?.id;
	const isEngaged = (subscription?.commitmentEndDate && moment(subscription.commitmentEndDate) > moment()) || subscription?.priceId === engagedPriceId;

	if (isActive && isCurrentPrice) {
		if (subscription?.cancelled === true) {
			return (<div className={"subs-btn btn blue rounded"} onClick={handleManage} style={{ cursor: 'pointer' }}>
				<p className='duration'>Votre abonnement sera résilié le</p>
				<p className='price'>{moment(subscription.next_renewal).format('DD/MM/YYYY')}</p>
				<p style={{ margin: 0, fontSize: '12px', marginTop: '10px' }}>
					{isEngaged
						? `Votre abonnement est actif jusqu'à la fin du contrat${subscription?.commitmentEndDate ? ' (' + moment(subscription.commitmentEndDate).format('DD/MM/YYYY') + ')' : ''}, votre carte sera débitée chaque mois.`
						: "Votre abonnement est bien annulé et votre carte ne sera plus débitée, mais vous pouvez encore profiter de nos service."
					}
				</p>
				<p style={{ margin: 0, fontSize: '12px', marginTop: '10px', textDecoration: 'underline' }}>Accéder à mes factures</p>
				{!isEngaged && (
					<div className="btn green sm rounded"
						style={{ marginTop: '15px', padding: '5px 10px', fontSize: '12px', display: isEngaged ? 'none' : 'block' }}
						onClick={(e) => { e.stopPropagation(); handleReactivate(); }}>
						Réactiver mon abonnement
					</div>
				)}
			</div>)
		} else {
			return (
				<>
					<div className={"subs-btn btn grey rounded"} style={{ backgroundColor: '#aaa', cursor: 'default' }}>
						<p className='duration'>Cet abonnement est actif</p>
						<p className='price'>{price?.amount ? (price.amount / 100).toFixed(2) + '€' : '...'} {periodLabel}</p>
						<p style={{ margin: 0, fontSize: '12px' }}>PROCHAIN PRÉLÈVEMENT LE {moment(subscription.next_renewal).format('DD/MM/YYYY')}</p>
					</div>

					{/* Hide Cancel button if it's an engaged plan */}
					{!isEngaged && (
						<div className={"subs-btn btn red rounded"} onClick={handleTerminate} style={{ marginTop: '10px' }}>
							<p className='duration'>Résilier mon abonnement</p>
						</div>
					)}
					{isEngaged && (
						<p style={{ fontWeight: 'bold', marginTop: '15px', fontSize: '14px', textAlign: 'center' }}>
							{subscription?.commitmentEndDate
								? `Vous êtes engagé jusqu'au ${moment(subscription.commitmentEndDate).format('DD/MM/YYYY')}. Vous ne pouvez pas changer de formule ou résilier avant cette date.`
								: `Vous êtes engagé. Vous ne pouvez pas changer de formule ou résilier avant la fin de votre période d’engagement. Vous disposez d'un délai de rétractation que vous pouvez exercer en contactant notre service client.`
							}
						</p>
					)}
					<p style={{ margin: 0, fontSize: '12px', marginTop: '10px', textDecoration: 'underline', cursor: 'pointer' }} onClick={handleManage}>Gérer mon abonnement</p>
				</>
			)
		}
	} else if (isActive && !isCurrentPrice) {
		// If user is engaged, they CANNOT switch to the other plan
		if (isEngaged) {
			return (
				<div className={"subs-btn btn grey rounded"} style={{ backgroundColor: '#ccc', cursor: 'not-allowed', opacity: 0.5 }}>
					<p className='duration'>S'abonner pour</p>
					<p className='price'>{price?.amount ? (price.amount / 100).toFixed(2) + '€' : '...'} {periodLabel}</p>
					<p style={{ margin: 0 }}>{subtext}</p>
				</div>
			)
		}

		return (
			<div className={"subs-btn btn blue rounded"} onClick={() => handleUpgrade(price?.id)}>
				<p className='duration'>Passer à cette formule</p>
				<p className='price'>{price?.amount ? (price.amount / 100).toFixed(2) + '€' : '...'} {periodLabel}</p>
				<p style={{ margin: 0 }}>{subtext}</p>
			</div>
		)
	} else {
		return (
			<div className={"subs-btn btn blue rounded"} onClick={() => handleSubscribe(price?.id)}>
				<p className='duration'>S'abonner pour</p>
				<p className='price'>{price?.amount ? (price.amount / 100).toFixed(2) + '€' : '...'} {periodLabel}</p>
				<p style={{ margin: 0 }}>{subtext}</p>
			</div>
		)
	}
};


export default class Subscriptions extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			clicked: false,
			subscription: props.userData?.subscription
		}
	}

	componentDidMount() {
		ReactGA.pageview("subscriptions")
		this.getPrices()
		this.fetchRealTimeStatus()
	}

	fetchRealTimeStatus = async () => {
		try {
			const headers = {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'authorization': this.props.auth.token,
			};
			const { data } = await axios.get(this.props.apiAddress + '/v2/stripe/subscription', { headers });
			if (data && (data.id || data.status)) {
				this.setState({ subscription: { ...this.state.subscription, ...data } });
			} else if (data === null) {
				// Consider null as explicit "no subscription" if your API uses that
				// But based on user request, it seems it refreshes to "nothing" wrongly
				// So if we have a subscription in state, we might want to keep it or verify why API returns nothing.
				// For now, let's be safer:
				// this.setState({ subscription: null }); 
			}
		} catch (err) {
			console.warn('Could not fetch real-time status:', err);
			// Do NOT clear subscription on error to avoid flickering if it was already loaded from props
		}
	}

	handleSubscribe = (priceId) => {
		if (!priceId) return;
		this.setState({ loading: true });
		this.pay(priceId);
	}

	handleTerminate = () => {
		confirmAlert({
			title: 'Voulez-vous résilier votre abonnement ?',
			message: 'Votre abonnement restera actif jusqu\'à la fin de la période en cours. Vous ne serez plus prélevé après cette date.',
			buttons: [
				{
					label: 'Résilier',
					onClick: async () => {
						try {
							const headers = {
								'Accept': 'application/json',
								'Content-Type': 'application/json',
								'authorization': this.props.auth.token,
							};
							const { data } = await axios.post(this.props.apiAddress + '/v2/stripe/cancel', {}, { headers });

							// Optimistically update
							if (data?.status === 'canceled' || data?.cancelAtPeriodEnd) {
								this.setState(prevState => ({
									subscription: {
										...prevState.subscription,
										cancelled: true,
										status: data.status,
										next_renewal: data.currentPeriodEnd
									}
								}));
							} else {
								this.fetchRealTimeStatus();
							}
						} catch (err) {
							console.error(err);
						}
					}
				},
				{
					label: 'Non, je reste!',
					onClick: null
				}
			]
		});
	}

	handleReactivate = async () => {
		try {
			const headers = {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'authorization': this.props.auth.token,
			};
			this.setState({ loading: true });
			const { data } = await axios.post(this.props.apiAddress + '/v2/stripe/reactivate', {}, { headers });

			if (data?.cancelAtPeriodEnd === false) {
				this.setState(prevState => ({
					subscription: {
						...prevState.subscription,
						cancelled: false,
						status: 'active'
					},
					loading: false
				}));
			} else {
				this.fetchRealTimeStatus();
				this.setState({ loading: false });
			}
		} catch (err) {
			console.error('Error reactivating:', err);
			this.setState({ loading: false });
		}
	}

	handleUpgrade = (newPriceId) => {
		confirmAlert({
			title: 'Changer d\'abonnement ?',
			message: 'Votre abonnement sera modifié immédiatement.',
			buttons: [
				{
					label: 'Confirmer',
					onClick: async () => {
						try {
							const headers = {
								'Accept': 'application/json',
								'Content-Type': 'application/json',
								'authorization': this.props.auth.token,
							};
							this.setState({ loading: true });
							const { data } = await axios.post(this.props.apiAddress + '/v2/stripe/upgrade', { newPriceId }, { headers });

							this.setState(prevState => ({
								subscription: {
									...prevState.subscription,
									priceId: newPriceId, // Optimistic update of priceId? 
									status: 'active'
								},
								loading: false
							}));
							this.fetchRealTimeStatus(); // Refresh to be sure
						} catch (err) {
							console.error('Error upgrading:', err);
							this.setState({ loading: false });
						}
					}
				},
				{ label: 'Annuler' }
			]
		});
	}

	handleManage = async () => {
		try {
			const headers = {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': this.props.auth.token,
			};
			const { data } = await axios.post(this.props.apiAddress + '/v2/stripe/create-portal-session', { returnUrl: window.location.href }, { headers });
			if (data?.url) {
				window.open(data.url, '_blank');
			}
		} catch (err) {
			console.error('Error opening customer portal:', err);
		}
	}

	getPrices = async () => {
		try {
			const headers = {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'authorization': this.props.auth.token,
			};
			const { data } = await axios.get(this.props.apiAddress + '/v2/stripe/prices', { headers });
			this.setState({ prices: data.prices });
		} catch (err) {
			console.error(err);
		}
	}

	pay = async (priceId) => {
		try {
			const headers = {
				'Accept': 'application/json',
				'Authorization': this.props.auth.token,
				'Content-Type': 'application/json'
			}
			const data = { priceId };
			const { data: result } = await axios.post(this.props.apiAddress + '/v2/profile/subscribe/form', data, { headers })
			ReactGA.event({
				category: 'Subscription',
				action: 'clicked on subscribe',
			})
			if (result?.url) {
				window.open(result.url, '_blank');
			}
			setTimeout(() => {
				this.setState({ loading: false });
				this.props.comeBack();
			}, 1000);
		} catch (err) {
			console.error('Error creating checkout session:', err);
			this.setState({ loading: false });
		}
	}

	render() {
		const { subscription } = this.state;
		return (
			<div className="subs container" style={{ textAlign: 'center' }}>
				<MdArrowBack
					onClick={() => this.props.comeBack()}
					fontSize="30px"
					style={{ position: "absolute", top: "10px", left: "10px", cursor: "pointer" }}
					color="#666"
				/>
				<p className="subs-title" >Abonnement</p>
				<p className="subs-description">Grâce à votre abonnement mensuel, profitez de manière illimitée du service Explique-Moi Pythagore : vous pourrez demander un professeur où vous voulez, quand vous voulez !</p>
				<div className={"subs-btns"}>
					{this.state.prices?.monthly &&
						<SubBtn
							price={this.state.prices?.monthly}
							subscription={subscription}
							handleSubscribe={this.handleSubscribe}
							handleTerminate={this.handleTerminate}
							handleManage={this.handleManage}
							handleReactivate={this.handleReactivate}
							handleUpgrade={this.handleUpgrade}
							subtext="Sans engagement"
							engagedPriceId={this.state.prices?.monthlyEngaged?.id}
							periodLabel="/ mois"
						/>
					}
					{this.state.prices?.monthlyEngaged &&
						<SubBtn
							price={this.state.prices?.monthlyEngaged}
							subscription={subscription}
							handleSubscribe={this.handleSubscribe}
							handleTerminate={this.handleTerminate}
							handleManage={this.handleManage}
							handleReactivate={this.handleReactivate}
							handleUpgrade={this.handleUpgrade}
							subtext="Avec engagement 1 an"
							engagedPriceId={this.state.prices?.monthlyEngaged?.id}
							periodLabel="/ mois"
						/>
					}
				</div>

				<br />
				<p style={{ fontSize: '12px', color: '#999', marginTop: '20px' }}>
					Le paiement est sécurisé par Stripe. Vous serez redirigé vers une page de paiement sécurisée.
				</p>
			</div>
		)
	}
}
